export default __webpack_public_path__ + "static/media/spin-bg-18.3b43a557.png";